import Container from '../components/Container';
import { TESTFLIGHT_URL } from '../lib/platform';

export default function Support() {
  return (
    <Container narrow>
      <p className="eyebrow">Here to help</p>
      <h1 className="mt-4 text-5xl font-bold tracking-tight text-djinn-text">Support.</h1>
      <p className="mt-5 max-w-xl text-lg leading-relaxed text-djinn-text-2">
        Need help with DJINN? Email us at{' '}
        <a className="djinn-link" href="mailto:support@djinncoach.com">
          support@djinncoach.com
        </a>{' '}
        and we'll reply within two business days.
      </p>

      <h2 className="mt-14 border-t border-djinn-border pt-10 text-2xl font-semibold text-djinn-text">
        Frequently asked questions
      </h2>

      <div className="mt-6 space-y-3">
        {[
          {
            q: 'How do I install the iPhone beta?',
            a: (
              <>
                Install Apple TestFlight from the App Store, then open our{' '}
                <a className="djinn-link" href={TESTFLIGHT_URL} target="_blank" rel="noopener noreferrer">
                  DJINN invitation link
                </a>{' '}
                on your iPhone. Accept the invitation and tap Install in TestFlight.
              </>
            ),
          },
          {
            q: "I didn't get a verification email.",
            a: (
              <>
                Check your spam folder for a message from{' '}
                <code className="rounded bg-white/10 px-1.5 py-0.5 text-sm">
                  noreply@djinncoach.com
                </code>
                . If it's still missing, open the app and tap "Resend verification email".
              </>
            ),
          },
          {
            q: 'How do I reset my password?',
            a: 'Tap "Forgot password" on the login screen and follow the link we send to your inbox.',
          },
          {
            q: 'How do I delete my account?',
            a: "Go to Profile → Settings → Delete account, or email us and we'll process the deletion within seven days.",
          },
          {
            q: 'Can I use Djinn Coach without notifications?',
            a: "Yes. The app works fully without push notifications — you'll just need to open it manually to check today's workout.",
          },
        ].map((item) => (
          <div key={item.q} className="djinn-card p-5">
            <h3 className="font-medium text-djinn-text">{item.q}</h3>
            <p className="mt-1.5 text-djinn-text-2">{item.a}</p>
          </div>
        ))}
      </div>
    </Container>
  );
}
